import { AdvancedDraftingValidationStates } from "constants/draftingAttributes";
import { ExportSite } from "constants/exportSites";
import { getAuctionsPlusValidationErrorsOrStatus } from "lib/validation/auctionsPlusValidation";
import { getStockliveValidationErrorsOrStatus } from "lib/validation/stockLiveValidation";

const defaultStatus = () => AdvancedDraftingValidationStates.SUCCESS;

export const ExportSiteValidationErrorOrStatusGetter = {
  [ExportSite.AUCTIONS_PLUS]: getAuctionsPlusValidationErrorsOrStatus,
  [ExportSite.ANGUS_AUSTRALIA]: defaultStatus,
  [ExportSite.STOCK_LIVE]: getStockliveValidationErrorsOrStatus,
  [ExportSite.AGRINOUS]: defaultStatus,
  [ExportSite.LIST_2_SELL]: defaultStatus,
  [ExportSite.FARMGATE]: defaultStatus,
  [ExportSite.THE_HERD]: defaultStatus,
};
